import styles from "../styles.module.scss";
import ButtonOption from "../ButtonOption";
import {useAppData} from "../../context/Contexts";
import {
    formatMoney,
    formatSelectedSeat, getCompareOfferPrice,
    getCurrency, getOfferPrice,
    parsedSeatUserFriendly
} from "../../helpers/helpers";
import React, {useState, useEffect, useRef} from "react";

export default function Step2(props) {
    const {currentAppData, setCurrentAppData} = useAppData();

    const [options, setOptions] = useState([]);
    const [product, setProduct] = useState({});
    const [savings, setSavings] = useState<undefined | string>(undefined);

    useEffect(() => {
        if (currentAppData === null) {
            return;
        }
        let product1: any;
        product1 = currentAppData.product;

        if (product1 && product1.options) {
            setProduct(product1);
            setOptions(product1.options.filter(option => option.name === 'Color'));
            // console.log('product options', options);
        }

    }, [currentAppData?.check, currentAppData?.product, currentAppData?.originalProduct])


    const handleChange = async (e) => {
        const new_value = e.target.value;

        // console.log('value: ', new_value);
        // console.log('currentAppData: ', currentAppData);


        // console.log('product step2', product);
        const filtered = product && product.variants && product.variants.edges.length > 0 ?
            product.variants.edges.filter(el => el.node.title.indexOf(new_value) === 0) : [];
        // console.log('filtered step2', filtered);
        if (filtered.length > 0) {

            if (document && document.querySelector('shopify-payment-terms'))
                document.querySelector('shopify-payment-terms').setAttribute('variant-id', filtered[0].node.id.replace('gid://shopify/ProductVariant/', ''));

            const currency = getCurrency(filtered[0].node.priceV2.currencyCode);
            //setPrice(currency + '' + formatMoney(parseFloat(filtered[0].node.priceV2.amount)));

            if (filtered[0].node.compareAtPrice) {
                // setComparePrice(currency + '' + filtered[0].node.compareAtPrice.amount);
                setSavings(currency + '' + formatMoney(filtered[0].node.compareAtPrice.amount - getOfferPrice(filtered[0].node.priceV2.amount)));
            } else {
                if (window.scs_show_earlybf_section) {
                    setSavings(currency + '' + formatMoney(20));
                }
                else {
                    setSavings(undefined);
                }
            }
        } else {
            setSavings(undefined);
        }

        let id = ''; //TODO: e.target.dataset.id.replace('gid://shopify/ProductVariant/', '');

        const filtered_by_color = currentAppData.product.variants.edges
            .filter(v => v.node.selectedOptions.filter(ep => ep.name === 'Color' && ep.value === e.target.value).length > 0);

        // console.log('filtered_by_color: ', filtered_by_color);
        if (filtered_by_color.length > 0)
            id = filtered_by_color[0].node?.id?.replace('gid://shopify/ProductVariant/', '');

        //alert(id);
        setCurrentAppData(prevState => {
            return {...prevState, color: new_value, selectedId: id}
        })
    }

    const handleClickChange = (e) => {
        // console.log('handleClickChange 2');
        setCurrentAppData(prevState => {
            return {...prevState, step: 2, color: ''}
        })
    }



    // console.log('Step2: ', currentAppData);

    return (<>
        {currentAppData?.step && currentAppData?.step > 1 ?
            <section className={`${styles.section__step} ${currentAppData?.step == 2 ? styles.section_active: ''}`} id="step_2">
                <h2>Step {currentAppData?.step}/{`${currentAppData.product.options.length + 1}`} - <strong>Options{/* (Add More, Save More)*/}</strong>

                </h2>
                <div className={`${styles.modal}`} id="leftModal" aria-hidden="true">
                    <div className={`${styles.modalDialog}`}>
                        <div className={`${styles.modalHeader}`}>
                            <h2>Custom Cover Solution</h2>
                            <a href="#" className={`${styles.btnClose}`} aria-hidden="true">×</a>
                        </div>
                        <div className={`${styles.modalBody}`}
                             dangerouslySetInnerHTML={{__html: `${window.custom_solution_body}`}}>
                        </div>

                    </div>
                </div>
                {currentAppData?.step === 2 ? (<>
                    <div
                        className={`${styles.seat_type_selector} `}>
                        {options.length > 0 && Array.from(
                            new Map(options[0].optionValues.map(item => [item.id, item])).values()
                        ).map(el => {
                            let price = '';
                            let comparePrice = '';
                            const priceEl = product.variants.edges.filter(v => v.node.selectedOptions
                                .filter(er => er.value === el.name).length > 0);
                            // console.log('priceEl:', priceEl);
                            if (priceEl.length > 0) {
                                const currency = getCurrency(priceEl[0].node.priceV2.currencyCode);
                                price = currency + formatMoney(getOfferPrice(parseFloat(priceEl[0].node.priceV2.amount)));

                                if (priceEl[0].node.compareAtPrice) {
                                    comparePrice = currency + formatMoney(getCompareOfferPrice(parseFloat(priceEl[0].node.priceV2.amount), parseFloat(priceEl[0].node.compareAtPrice.amount)));
                                }
                                else {
                                    if (window.scs_show_earlybf_section) {
                                        comparePrice = currency + formatMoney(parseFloat(priceEl[0].node.priceV2.amount));
                                    }
                                }
                            }


                            const id = 'btn_' + el.id.replace('gid://shopify/ProductOptionValue/', '');

                            return (<React.Fragment key={`wrapper-${el.id}`}><ButtonOption key={el.id}
                                                    comparePrice={comparePrice} price={price}
                                                    value={el.name} id={id} name="Seats[]"
                                                    onChange={handleChange}
                                                    display={true}
                                                    enabled={true}
                                                    type={'radio'}
                                                    checked={currentAppData.color && currentAppData.color.split(',').includes(el.name)}

                            />

                            </React.Fragment>);
                        })}
                    </div>
                    {savings ? (
                        <div className={`${styles.savings}`}>
                            <svg width="15" height="16" viewBox="0 0 15 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_953_3054)">
                                    <path
                                        d="M13.7499 0.110046H8.55454C8.21086 0.110046 7.7305 0.309154 7.48767 0.551803L0.364771 7.67466C-0.12159 8.16048 -0.12159 8.95698 0.364771 9.4422L5.66835 14.7456C6.15361 15.2314 6.94934 15.2314 7.43534 14.745L14.5582 7.62328C14.8008 7.38067 15 6.89955 15 6.55659V1.3601C15 0.672725 14.4373 0.110046 13.7499 0.110046ZM11.2498 5.11007C10.5594 5.11007 9.99975 4.54981 9.99975 3.86002C9.99975 3.16909 10.5594 2.60997 11.2498 2.60997C11.9402 2.60997 12.5 3.16909 12.5 3.86002C12.5001 4.54981 11.9402 5.11007 11.2498 5.11007Z"
                                        fill="black"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_953_3054">
                                        <rect width="15" height="15" fill="white" transform="translate(0 0.109924)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            You Saved: <span className={`${styles.savings_price}`}>{savings}</span>
                        </div>
                    ) : ''}
                    {window.scs_step_1_bottom_text ? <div className={`${styles.bottom_text}`} dangerouslySetInnerHTML={{__html: `${window.scs_step_1_bottom_text}`}}></div> : ''}
                </>) : (<div className={`${styles.summary}`}>
                    <div
                        className={`${styles.selected_value}`}>{`${parsedSeatUserFriendly(formatSelectedSeat(currentAppData?.seat, product, currentAppData?.check?.compatibility_custom), currentAppData?.check?.compatibility_custom)}`}</div>
                    <button className={`${styles.btn_change}`} onClick={handleClickChange}>Change Seat Type</button>

                </div>)}


            </section> : ''}
    </>);
}